export const SET_TOKEN = "SET_TOKEN";
export const ADD_USER = "ADD_USER";
export const FETCH_MOVIE_LIST_PAGINATION = "FETCH_MOVIE_LIST_PAGINATION";
export const FETCH_MOVIE_LIST = "FETCH_MOVIE_LIST";
export const FETCH_MOVIE_LIST_COMING_SOON = "FETCH_MOVIE_LIST_COMING_SOON";
export const FETCH_BOOKING_MOVIE = "FETCH_BOOKING_MOVIE";
export const FETCH_DETAIL_MOVIE = "FETCH_DETAIL_MOVIE";
export const FETCH_CINEMA_LIST = "FETCH_CINEMA_LIST";
export const FETCH_CINEMA_BY_CODE = "FETCH_CINEMA_BY_CODE";
export const FETCH_SHOWTIME_BY_MOVIE = "FETCH_SHOW_TIME_BY_MOVIE"; 
export const FETCH_TICKET_ROOM = "FETCH_TICKET_ROOM";
export const FETCH_INFO_SHOWTIME = "FETCH_INFO_SHOWTIME";
export const PUSH_SELECTED_MOVIE = "PUSH_SELECTED_MOVIE";
export const PUSH_SELECTED_SEAT = "PUSH_SELECTED_SEAT";
export const MY_REF = "MY_REF";
export const USER_INFO = "USER_INFO";
export const TICKET_BOOKED = "TICKET_BOOKED"; 
export const URL = "http://movieapi.cyberlearn.vn/api/QuanLyRap";
export const HIDDEN_LOADING = "HIDDEN_LOADING";
export const DISPLAY_LOADING = "DISPLAY_LOADING";
export const BOOKING_SUCCESS = "BOOKING_SUCCESS";
export const FETCH_MOVIE_INFO = "FETCH_MOVIE_INFO";
export const FETCH_USERS_LIST = "FETCH_USERS_LIST";

